<template>
  <page-tab
    :banner="banner"
    :breadcrumb="breadcrumb"
    :tabList="tabList"
    listKey="code"
    v-model="tabCurrent"
    @change="tabChange"
  >
    <div class="products">
      <ul>
        <li v-for="(item, j) in products" :key="j" @click="toDetail(item.id)">
          <div
            class="image"
            :style="{ backgroundImage: `url(${item.icon})` }"
          ></div>
          <div class="info">
            <h2>{{ item.title }}</h2>
            <p>{{ item.summary }}</p>
          </div>
        </li>
      </ul>
    </div>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />
    <el-empty description="暂无数据" v-show="total < 1"></el-empty>
  </page-tab>
</template>
<script>
import PageTab from "@/components/PageTab.vue";
import banner from "@/assets/images/banner/product.png";
import { getAllCategory, getProductList } from "@/api/index";

export default {
  name: "Product",
  components: {
    PageTab,
  },
  data() {
    return {
      banner,
      products: [],
      breadcrumb: [
        { name: "首页", path: "/" },
        { name: "产品中心", path: "" },
        { name: "", path: "" },
      ],
      tabList: [],
      tabCurrent: "",
      queryParams: {
        pageNum: 1,
        pageSize: 2,
      },
      total: 0,
    };
  },
  created() {
    this.getAllCategory();
  },
  methods: {
    tabChange(item) {
      this.breadcrumb[2].name = item.name;
      this.queryParams.pageNum = 1;
      this.getList();
    },
    getAllCategory() {
      getAllCategory().then((res) => {
        this.tabList = res.data;
        this.tabCurrent = this.tabList[0].code;
        this.getList();
      });
    },
    getList() {
      const params = {
        ...this.queryParams,
        code: this.tabCurrent,
      };
      getProductList(params).then((res) => {
        this.products = res.data && res.data.records;
        this.total = res.data && res.data.total;
      });
    },
    toDetail(id) {
      this.$router.push(`/productDetail?id=${id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss"; // global css
.products {
  ul {
    li {
      overflow: hidden;
      cursor: pointer;
      line-height: 1.7;
      color: #ffffff;
      &:nth-child(2n) {
        color: #000;
        .image {
          float: right;
        }
        .info {
          background: #eeedf0;
        }
      }
      &:hover {
        .info {
          h2 {
            text-decoration: underline;
          }
          p {
            text-decoration: underline;
          }
        }
      }
      .image {
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        width: 50%;
        height: 480px;
        float: left;
      }
      .info {
        box-sizing: border-box;
        width: 50%;
        height: 480px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        padding: 30px 100px;
        background: $main-color;
        h2 {
          font-weight: normal;
          font-size: 26px;
          @include clamp(2);
        }
        p {
          margin-top: 40px;
          font-size: 18px;
          @include clamp(4);
        }
      }
    }
  }
}
.isMobile {
  .products {
    ul {
      li {
        margin-top: 16px;
        &:first-child {
          margin-top: 0;
        }
        .image {
          width: 100%;
          height: 240px;
          float: none;
        }
        .info {
          width: 100%;
          padding: 12px 20px;
          height: auto;
          h2 {
            font-size: 16px;
          }
          p {
            margin-top: 20px;
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
